(() => {
  if (window.RavinHideDefInstalled) return;
  window.RavinHideDefInstalled = true;
  const exact = value => String(value ?? '').trim().toUpperCase() === 'DEF';
  const inVariantLabel = value => String(value ?? '').split('/').some(part => exact(part.replace(/\s*[-–—]\s*(sold out|unavailable|not available)\s*$/i, '')));
  const scheduled = new Set();
  const selectMatches = 'select';

  function scrubSelect(select) {
    const hasVariantIds = select.name === 'id' || /variant/i.test(select.name);
    const removed = Array.from(select.options).filter(option => exact(option.value) || exact(option.textContent) || (hasVariantIds && inVariantLabel(option.textContent)));
    if (!removed.length) return;
    const hadSelectedDef = removed.some(option => option.selected);
    removed.forEach(option => option.remove());
    if (select.options.length === 0) {
      select.disabled = true;
      const form = select.closest('form');
      form?.querySelectorAll('button[type="submit"]').forEach(button => button.disabled = true);
      return;
    }
    if (hadSelectedDef) {
      const first = Array.from(select.options).find(option => !option.disabled) || select.options[0];
      if (!first) return;
      first.selected = true;
      select.querySelectorAll('option[selected]').forEach(option => option.removeAttribute('selected'));
      first.setAttribute('selected', 'selected');
      queueMicrotask(() => { if (select.isConnected) select.dispatchEvent(new Event('change', { bubbles:true })); });
    }
  }

  function scrubRadios(group) {
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
    const bad = radios.filter(radio => exact(radio.value));
    if (!bad.length) return;
    const selectedBad = bad.find(radio => radio.checked);
    bad.forEach(radio => {
      const id = radio.id;
      const label = Array.from(group.querySelectorAll('label[for]')).find(node => node.htmlFor === id);
      const wrap = radio.closest('.swatch-input-wrapper');
      if (wrap) wrap.remove();
      else radio.remove();
      label?.remove();
    });
    if (selectedBad) {
      const fallback = Array.from(group.querySelectorAll('input[type="radio"]')).find(input => !input.disabled && !input.classList.contains('disabled'));
      if (fallback) {
        fallback.checked = true;
        queueMicrotask(() => { if (fallback.isConnected) fallback.dispatchEvent(new Event('change', { bubbles:true })); });
      } else {
        group.closest('product-info')?.querySelectorAll('button[name="add"]').forEach(button => button.disabled = true);
      }
    }
  }

  function scrub(scope) {
    if (!(scope instanceof Element) && scope !== document) return;
    const get = selector => {
      const matched = scope instanceof Element && scope.matches(selector) ? [scope] : [];
      return matched.concat(Array.from(scope.querySelectorAll(selector)));
    };
    get(selectMatches).forEach(scrubSelect);
    get('variant-selects fieldset').forEach(scrubRadios);
    get('variant-selects[data-ravin-initial-def="true"]').forEach(node => {
      if (node.dataset.ravinDefSynced === 'true') return;
      node.dataset.ravinDefSynced = 'true';
      const target = node.querySelector('select:not(:disabled)') || node.querySelector('input[type="radio"]:checked');
      if (target) queueMicrotask(() => { if (target.isConnected) target.dispatchEvent(new Event('change', { bubbles: true })); });
    });
    get('.ravin-filters [data-ravin-facet-value], .facets__item input[type="checkbox"], .mobile-facets__item input[type="checkbox"]').forEach(node => {
      const value = node.dataset.ravinFacetValue ?? node.value;
      if (!exact(value)) return;
      if (node.matches('[data-ravin-facet-value]')) node.remove();
      else node.closest('.facets__item, .mobile-facets__item')?.remove();
    });
    get('.cart-item .product-option, #CartDrawer .product-option').forEach(node => {
      const dd = node.querySelector('dd');
      if (dd && exact(dd.textContent)) node.remove();
    });
    get('.variant-item').forEach(row => {
      const title = row.querySelector('.variant-item__name')?.textContent || '';
      if (title.split('/').some(part => exact(part))) row.remove();
    });
    get('variant-selects [data-selected-value]').forEach(node => {
      if (!exact(node.textContent)) return;
      const fieldset = node.closest('fieldset');
      const current = fieldset?.querySelector('input:checked');
      if (current && !exact(current.value)) node.textContent = current.value;
    });
  }

  let timer = null;
  function onMutations(mutations) {
    for (const record of mutations) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        scheduled.add(node);
      }
    }
    if (!scheduled.size || timer !== null) return;
    timer = requestAnimationFrame(() => {
      timer = null;
      const targets = Array.from(scheduled);
      scheduled.clear();
      targets.forEach(node => { if (node.isConnected) scrub(node); });
    });
  }

  function init() {
    scrub(document);
    const observer = new MutationObserver(onMutations);
    observer.observe(document.body, {childList:true,subtree:true});
    document.addEventListener('shopify:section:load', event => scrub(event.target));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();